import Cookies from 'js-cookie';
import { omitBy, isNil } from 'lodash-es';
import {
  GOOGLE_ANALYTICS_ID_COOKIE_NAME,
  TRACKING_CONTEXT_SCHEMA,
  SNOWPLOW_JS_SOURCE,
} from './constants';

export default function getStandardContext() {
  const { environment, customerId = null } = window.snowplowContext || {};
  return {
    schema: TRACKING_CONTEXT_SCHEMA,
    data: {
      environment,
      source: SNOWPLOW_JS_SOURCE,
      google_analytics_id: Cookies.get(GOOGLE_ANALYTICS_ID_COOKIE_NAME) ?? null,
      customer_id: customerId,
    },
  };
}

export function getContext(options = {}) {
  const {
    flowCategory,
    zuoraAccountNumber,
    namespaceId,
    subscriptionName,
    productRatePlanProductName,
    productRatePlanId,
    baseProductName,
    baseProductId,
    entryPoint,
    promoCodePresent,
  } = options;
  const { schema, data } = getStandardContext();

  return {
    schema,
    data: omitBy(
      {
        ...data,
        flow_category: flowCategory,
        zuora_account_number: zuoraAccountNumber,
        namespace_id: namespaceId,
        subscription_name: subscriptionName,
        product_rate_plan_product_name: productRatePlanProductName,
        product_rate_plan_id: productRatePlanId,
        base_product_name: baseProductName,
        base_product_id: baseProductId,
        entry_point: entryPoint,
        promo_code_present: promoCodePresent,
      },
      isNil,
    ),
  };
}
